export default __webpack_public_path__ + "static/media/comedora-fondo-nuevo.627d174f.jpg";